module.exports = __webpack_public_path__ + "img/rivendell-3018-10-24.08b161d2.jpg";